import * as THREE from 'three'
import React from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'
import { frontBasicMaterial } from '../utils/materials'

type GLTFResult = GLTF & {
  nodes: {
    garage: THREE.Mesh
    brew_table: THREE.Mesh
    barril: THREE.Mesh
    chemical: THREE.Mesh
    mixture: THREE.Mesh
    hose: THREE.Mesh
    hose2: THREE.Mesh
    hose3: THREE.Mesh
    mixer: THREE.Mesh
    barril_holder: THREE.Mesh
    beer_crate: THREE.Mesh
    crate: THREE.Mesh
    crate2: THREE.Mesh
    beer_crate2: THREE.Mesh
    empty_bottle: THREE.Mesh
  }
}

export function Brewing(props: JSX.IntrinsicElements['group']) {
  const { nodes } = useGLTF(require('../assets/3D/brewing.glb')) as GLTFResult
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.garage.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.brew_table.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.barril.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.chemical.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.mixture.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.hose.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.hose2.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.hose3.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.mixer.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.barril_holder.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.beer_crate.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.crate.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.crate2.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.beer_crate2.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.empty_bottle.geometry} material={frontBasicMaterial} />
    </group>
  )
}

useGLTF.preload(require('../assets/3D//brewing.glb'))
